<template>
  <v-dialog v-model="isOpen" width="600" class>
    <v-card class>
      <v-card-title>
        <span class="headline">{{$t('titles.moveMedia')}}</span>
      </v-card-title>
      <v-layout justify-center wrap>
      <div v-if="loader" class="loader">
        <v-icon>mdi-loading mdi-spin</v-icon>
      </div>
        <v-flex md9 xs12>
        <itt-combobox :projects="projects" @changeSelect="getSelectedProject"></itt-combobox>
        </v-flex>
      </v-layout>
      <v-card-actions class="center">
        <v-btn color="primary" flat @click="toggle">{{$t('buttons.close')}}</v-btn>
        <v-btn color="primary" flat @click="saveAndGo()">{{$t('buttons.move')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { router } from "@/_helpers";
import ittCombobox from '@/components/projects/itt-combobox';

export default {
  components: {
    ittCombobox
  },
  data() {
    return {
      name: "",
      projects: [],
      selectedProject: "",
      loader: false
    };
  },
  computed: {
    isOpen: {
      get() {
        let projs = this.$store.getters["project/getProjects"];
        if (projs !== 'null')
          this.projects = [...projs];
        return this.$store.getters["dialogModal/isOpenMovedir"];
      },
      set() {
        this.toggle();
        return this.$store.getters["dialogModal/isOpenMovedir"];
      }
    },
  },
  methods: {
    getSelectedProject(newSelect) {
      this.selectedProject = newSelect;
    },
    toggle() {
      this.$store.dispatch("dialogModal/toggleMovedir");
    },

    saveAndGo() {
      this.loader = true;
      setTimeout(async () => {
        let projectToGo = await this.selectOrCreateProjects(this.selectedProject, this.projects);
        let imgsToMove = this.$store.getters["image/getMultiSelectImg"];
        let promises = imgsToMove.map(
          uuidImg => this.$store.dispatch("image/updateMediaProject", [uuidImg, projectToGo.uuid])
        );
        await Promise.all(promises)
        await this.$store.dispatch("image/getImages");
        this.loader = false;
        this.$store.commit("image/emptyMultiSelectImg");
        // await this.$store.getters["image/getImgProject"](this.$route.params.uuid);
        this.toggle();
      }, 10);
    }
  }
};
</script>
<style lang="sass" scoped>
.loader 
  position: absolute
  top: 0
  bottom: 0
  background: #1c1c1c
  opacity: .8
  width: 100%
  text-align: center
  display: flex 
  z-index: 10
  i 
    font-size: 3rem
    margin: auto
</style>
